import { useAppSSE } from 'contexts/AppSSEContext';
import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import {
  addAlertFromEvent,
  applyAlertUpdatesFromEvent,
  removeAlertFromEvent,
} from 'services/alerts/alerts.service';

// keep your dev-only helper exactly as-is
const notifySseActivity =
  process.env.NODE_ENV === 'development'
    ? require('components/DevRenderOverlay/sseActivityHelper').notifySseActivity
    : () => {};

export default function useAlertsEvents({ enabled = true } = {}) {
  const dispatch = useDispatch();
  const { subscribe } = useAppSSE();

  const handlers = useMemo(
    () => ({
      'alert-add': (eventData) => {
        notifySseActivity('alert-add');
        addAlertFromEvent(dispatch, eventData);
      },
      'alert-update': (eventData) => {
        notifySseActivity('alert-update');
        applyAlertUpdatesFromEvent(dispatch, eventData);
      },
      'alert-remove': (eventData) => {
        notifySseActivity('alert-remove');
        removeAlertFromEvent(dispatch, eventData);
      },
    }),
    [dispatch],
  );

  useEffect(() => {
    if (!enabled) return;

    const unsubs = Object.entries(handlers).map(([eventType, handler]) =>
      subscribe(eventType, handler),
    );

    return () => unsubs.forEach((unsub) => unsub());
  }, [enabled, subscribe, handlers]);
}
